/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiInsurances,
    ApiInsurancesFromJSON,
    ApiInsurancesToJSON,
} from '../models';

export interface GetAllInsurancesRequest {
    claimId: string;
}

/**
 * 
 */
export class InsuranceProviderApi extends runtime.BaseAPI {

    /**
     * get insurance by country
     */
    async getAllInsurancesRaw(requestParameters: GetAllInsurancesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiInsurances>> {
        if (requestParameters.claimId === null || requestParameters.claimId === undefined) {
            throw new runtime.RequiredError('claimId','Required parameter requestParameters.claimId was null or undefined when calling getAllInsurances.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/{claimId}/insurances`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters.claimId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiInsurancesFromJSON(jsonValue));
    }

    /**
     * get insurance by country
     */
    async getAllInsurances(requestParameters: GetAllInsurancesRequest, initOverrides?: RequestInit): Promise<ApiInsurances> {
        const response = await this.getAllInsurancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
